export enum PAGE_TYPE {
  PDP = 'Product Detail Page',
  LISTING = 'listing page',
  SEARCH = 'Search Page',
  HOMEPAGE = 'home page',
  OFFERPAGE = 'offer page',
  LANDINGPAGE = 'landing page',
  SIGNUPLOGINPAGE = 'signup login page',
  IMAGE_GALLERY_VIEW = 'imageGallery',
  SHOP = 'shopPage',
  APPPROMOPAGE = 'App download promo page',
  ERROR = 'errorPage',
  MY_ACCOUNT = 'accountPage',
  WISHLIST = 'wishlist',
  CMSPAGE = 'cms page',
  WIDGET_LISTING = 'Widget',
  CART_PAGE = 'checkoutpage',
  ADDRESS_PAGE = 'addresspage',
}

export enum EVENTS {
  PDP = 'product-detail-rule',
  LISTING = 'listing-page-rule',
  SEARCH = 'searchPage',
  HOMEPAGE = 'homepage',
  OFFERPAGE = 'offerpage',
  LANDINGPAGE = 'landingpage',
  MWEB_APP_INSTALL = 'MwebAppbnrclkd',
  IMAGE_GALLERY_VIEW = 'imageGalleryView',
  MEGA_MENU_SHOP_VIEW = 'mega-menu-page-view',
  ERROR = 'errorPage',
  MY_ACCOUNT = 'my-account-page-view',
  WISHLIST = 'wishlist-page-rule',
  WIDGET_LISTING = 'widget-listing-rule',
  PROFILE = 'profile-page-view',
  GIFT_CARD = 'giftcard-page-view',
  CART_PAGE = 'cart-v2-page-view',
}

export enum USER_STATUS {
  GUEST = 'guest',
  LOGGED_IN = 'logged in',
}

export const DEFAULT_CHANNEL = 'NDS';
export const DEFAULT_CURRENCY = 'INR';
export const REACT_IDENTIFIER = { BROWSER: 'react', STANDALONE: 'react-app' };

export const NYKAA_DTM_STORE_KEY = 'NYKAA_DTM_STORE';
